import { getFunctions, httpsCallable } from 'firebase/functions';
import { functions as configuredFunctions } from '../config/firebase';
import { CHAT_CHANNEL_META, membersForChannel } from './calendarV2Persist';

export function channelLabel(channelId) {
  const row = CHAT_CHANNEL_META.find((c) => c.id === channelId);
  return row?.name || String(channelId || 'Party-wide');
}

export function tourChatNotifyRecipients({
  members = [],
  membersMap,
  channelId,
  senderId,
  senderEmail,
} = {}) {
  const senderKey = String(senderId || '').trim();
  const senderMail = String(senderEmail || '').trim().toLowerCase();
  const pool = membersForChannel(membersMap, channelId, members);
  return pool.filter((m) => {
    const id = String(m?.id || m?.uid || '').trim();
    const email = String(m?.email || '').trim().toLowerCase();
    if (senderKey && id && id === senderKey) return false;
    if (senderMail && email && email === senderMail) return false;
    return Boolean(id || email);
  });
}

export function latestChatPreview(channels) {
  const rows = Object.entries(channels || {}).flatMap(([channelId, msgs]) => (
    (Array.isArray(msgs) ? msgs : []).map((m) => ({ ...m, channelId }))
  ));
  rows.sort((a, b) => Date.parse(String(b?.at || '')) - Date.parse(String(a?.at || '')));
  return rows[0] || null;
}

export function tourChatInboxThreadFromDoc(data = {}, id = '') {
  const tourId = String(data.tourId || id || '').trim();
  if (!tourId) return null;
  const channelId = String(data.channelId || 'party');
  const tourName = String(data.tourName || 'Tour chat').trim() || 'Tour chat';
  const lastAt = data.lastAt || data.updatedAt || null;
  return {
    id: `tourChat:${tourId}`,
    kind: 'tourChat',
    tourId,
    channelId,
    name: `${tourName} · ${channelLabel(channelId)}`,
    tourName,
    lastMessage: data.lastText
      ? {
          text: String(data.lastText),
          senderId: String(data.lastWhoId || ''),
          senderName: String(data.lastWho || ''),
          timestamp: lastAt,
        }
      : null,
    lastActivity: lastAt,
    unreadCounts: {},
    participantUsers: [],
    participants: [],
    photoURL: String(data.photoURL || '').trim(),
    isTourChat: true,
  };
}

export async function notifyTourChatMessage({
  tourId,
  tourName,
  channelId,
  message,
  members,
  membersMap,
  senderId,
  senderName,
  senderEmail,
  appUrl,
} = {}) {
  const recipients = tourChatNotifyRecipients({
    members,
    membersMap,
    channelId,
    senderId,
    senderEmail,
  }).map((m) => ({
    id: String(m.id || m.uid || '').trim(),
    email: String(m.email || '').trim(),
    name: String(m.name || m.displayName || '').trim(),
  }));
  if (!recipients.length || !tourId || !message?.text) return { skipped: true };

  const notifyTourChat = httpsCallable(configuredFunctions || getFunctions(), 'notifyTourChat');
  await notifyTourChat({
    tourId,
    tourName: tourName || 'Tour',
    channelId: channelId || 'party',
    channelName: channelLabel(channelId),
    text: String(message.text).slice(0, 400),
    senderId: senderId || '',
    senderName: senderName || 'Someone',
    senderEmail: senderEmail || '',
    lastAt: message.at || new Date().toISOString(),
    appUrl: appUrl || (typeof window !== 'undefined' ? `${window.location.origin}/calendar/chat` : 'https://venuereportcard.com/calendar/chat'),
    recipients,
  });
  return { sent: recipients.length };
}
